import React from 'react'
import { oee_dashboard_stats } from '../../Utils/constants'
import { clipboardText, favchart, maskGroup } from '../../Utils/imports'
import { useSelector } from 'react-redux'
import moment from 'moment'
import NoDataFound from '../Helpers/NoDataFound'
import { getPreviousProduct } from '../../Helpers/helpers'

const Stats = () => {

    const { current } = useSelector(state => state?.plant)
    //console.log(current);
    let { plant = null} = {current}
    const { stats: kpis = {} } = useSelector(state => state?.kpis)
    const {currentPro,previous} = getPreviousProduct(kpis,plant?.timezone);
    let render = oee_dashboard_stats.map((stats, i) =>
        <div key={i} className='stats'>
            <div className='info-1'>
                {current?.shift && <span className='speed'>
                    Speed:
                    <span className=''>{current?.line?.status?.status === 'up' ? current?.shift?.product?.lineSpeed : 0} Prod/min</span>
                    <img src={favchart} style={{ width: "18px" }} />
                </span>}
                <span className='batch-no'>
                    Batch No:
                    <span className=''>{kpis?.currentBatch?.batchNumber || 'XXXXXXXX'}</span>
                    <img src={clipboardText} style={{ width: "18px" }} />
                </span>
            </div>
            {current?.shift && <> <div className='current'>
                <span style={{ fontWeight: "bold" }}>Current</span>
                <div className='inner'>
                    <div className='dflex alignCenter justifyCenter'>
                        <img src={maskGroup} style={{ width: "35px", marginRight: "5px" }} />
                        <span className='name'>{currentPro?currentPro?.name :current?.shift?.product?.name}</span>
                    </div>
                    <span className='time'>{currentPro?(moment(currentPro?.rangeFrom).format('hh:mm') + '-' +  moment(currentPro?.rangeTo).format('hh:mm')):(current?.shift?.from + '-' + current?.shift?.to)}</span>
                </div>
            </div>
            
                <div className='previous'>
                    <span style={{ fontWeight: "bold" }}>Previous</span>
                    <div className='inner'>
                        <div className='dflex alignCenter justifyCenter'>
                            <img src={maskGroup} style={{ width: "35px", marginRight: "5px" }} />
                            <span className='name'>{previous?.name || 'N/A'}</span>
                        </div>
                        <span className='time'>{previous?(moment(previous?.rangeFrom).format('hh:mm') + '-' +  moment(previous?.rangeTo).format('hh:mm')):'N/A'}</span>
                    </div>
                </div>
            </>}
        </div>)

    return render

}

export default Stats